import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Mail } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Login successful');
    } catch (err) {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--void)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        style={{ maxWidth: 440, width: '100%', background: 'var(--surface)', border: '1px solid var(--border-dim)', padding: '3rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{ width: 70, height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem', background: 'rgba(235, 110, 31, 0.08)', border: '1px solid rgba(235, 110, 31, 0.25)' }}>
            <Shield size={32} style={{ color: 'var(--astros-orange)' }} />
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'white', letterSpacing: '0.1em', marginBottom: '0.5rem' }}>
            SECURE ACCESS
          </h1>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)' }}>
            Lone Star Bonding Co. | License No. 74629
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.25rem' }}>
            <label className="form-label"><Mail size={14} style={{ display: 'inline-block', marginRight: 6 }} /> EMAIL</label>
            <input type="email" className="form-input" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" required data-testid="login-email" style={{ fontSize: '1.05rem' }} />
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <label className="form-label"><Lock size={14} style={{ display: 'inline-block', marginRight: 6 }} /> PASSWORD</label>
            <input type="password" className="form-input" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Enter password" required data-testid="login-password" style={{ fontSize: '1.05rem' }} />
          </div>
          <button type="submit" className="btn-emergency" disabled={loading}
            style={{ width: '100%', justifyContent: 'center', fontSize: '1.1rem', opacity: loading ? 0.7 : 1 }}
            data-testid="login-submit">
            {loading ? 'LOGGING IN...' : 'LOGIN'}
          </button>
        </form>

        <div style={{ marginTop: '2rem', padding: '1rem', background: 'rgba(34, 197, 94, 0.06)', border: '1px solid rgba(34, 197, 94, 0.15)', fontSize: '0.8rem', color: 'var(--text-muted)', textAlign: 'center' }}>
          <Shield size={14} style={{ display: 'inline-block', marginRight: 6, verticalAlign: 'text-bottom', color: 'var(--success)' }} />
          Protected by TITN Aegis Security
        </div>
      </motion.div>
    </div>
  );
};

export default Login;
